/**
 * The people who help a customer, by one name and at one address everywhere the app points at them
 * (pass 3, 2026-10-06: five names, "Paige support", "Ademero support", "Paige's team", and no
 * address or link anywhere). The address is the one Paige's own mail is answered at
 * (`Lifecycle:ReplyTo`).
 */
export const SUPPORT_NAME = 'Ademero support';
export const SUPPORT_EMAIL = 'support@ademero.com';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
